<script lang="ts">
	export let isMonthly: boolean = false;
</script>

<div class="w-full h-8 p-1 flex flex-row justify-center items-center rounded text-xs bg-zinc-100 dark:bg-navy-800">
	<button
		class="w-1/2 h-full flex flex-row justify-center items-center rounded font-medium
			{isMonthly
				? 'text-zinc-900 bg-zinc-300 dark:text-zinc-100 dark:bg-navy-900'
				: 'text-zinc-500 dark:text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300'}"
		on:click={() => (isMonthly = true)}
	>
		Monthly
	</button>
	<button
		class="w-1/2 h-full flex flex-row justify-center items-center gap-1.5 rounded font-medium
			{!isMonthly
				? 'text-zinc-900 bg-zinc-300 dark:text-zinc-100 dark:bg-navy-900'
				: 'text-zinc-500 dark:text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300'}"
		on:click={() => (isMonthly = false)}
	>
		Yearly
		<span class="text-[10px] px-1 py-0.5 bg-emerald-700 dark:bg-emerald-900 text-emerald-100 dark:text-emerald-300 rounded font-medium {!isMonthly ? 'opacity-100' : 'opacity-80'}">-20%</span>
	</button>
</div>